/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Collapse, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DetailsItem from './DetailsItem';

const useStyles = makeStyles({
  collapse: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill,minmax(12.5rem, 1fr))',
    backgroundColor: '#E7F1FC',
  },
});

export default function DetailsCollapse({ open, party }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <div className={classes.collapse}>
        <DetailsItem name={t('parties.address')} value={party.address} />
        <DetailsItem name={t('parties.city')} value={party.city} />
        <DetailsItem name={t('parties.telephone')} value={party.telephone} />
        <DetailsItem name={t('parties.email')} value={party.email} />
        <DetailsItem name={t('parties.postal-code')} value={party.postalCode} />
        <DetailsItem name={t('parties.country')} value={party.country} />
        <DetailsItem name={t('parties.fax')} value={party.fax} />
      </div>
    </Collapse>
  );
}
